import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from '@blocks-react/components/Heading';
import { Conditional } from '../conditional';
import styles from './services-offered.module.scss';
import cx from 'classnames';
export const ServicesOffered = ({ title, servicesOffered = [], isStoreLocationOptimizationFlag = false }) => {
    const showServicesOffered = Array.isArray(servicesOffered) && !!servicesOffered.length;
    return (_jsxs(Conditional, { test: showServicesOffered, children: [_jsx(CatHeading, { level: "h2", variant: "title-sm", className: isStoreLocationOptimizationFlag ? 'mb-3' : '', children: title }), _jsx("p", { className: cx(styles['services-offered-text'], 'cat-u-theme-typography-body mb-0 pb-2'), children: servicesOffered.join(', ') })] }));
};
